export default "__VITE_PUBLIC_ASSET__3cd49e2a__"